// Browser persistence is optional: verified customers can finish this tab's
// session when storage is blocked. The token is sent only as an API Bearer
// header; it is never put in a URL or cookie.
const STORAGE_KEY = "pxn_auth_token";
let memoryToken = null;
let memoryOnly = false;

/** The current session token, or null. */
export function getToken() {
  if (typeof window === "undefined") return null;
  if (memoryOnly) return memoryToken;
  try {
    // A successful read owns the state, including another tab signing out.
    memoryToken = window.localStorage.getItem(STORAGE_KEY) || null;
    return memoryToken;
  } catch (_e) {
    return memoryToken;
  }
}

/** Persist after verification, falling back to this page session. */
export function setToken(token) {
  if (typeof window === "undefined") return;
  memoryToken = typeof token === "string" && token ? token : null;
  try {
    if (memoryToken) window.localStorage.setItem(STORAGE_KEY, memoryToken);
    else window.localStorage.removeItem(STORAGE_KEY);
    memoryOnly = false;
  } catch (_e) {
    memoryOnly = true;
  }
}

/** Sign out even if removal fails and leaves a stale stored token behind. */
export function clearToken() {
  memoryToken = null;
  if (typeof window === "undefined") return;
  try {
    window.localStorage.removeItem(STORAGE_KEY);
    memoryOnly = false;
  } catch (_e) {
    memoryOnly = true;
  }
}

export function authHeader() {
  const token = getToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}
